export default __webpack_public_path__ + "assets/images/442779d8a132d4108e11924d15e29c58.png";